export default __webpack_public_path__ + "static/media/1268.0c80fc1a.png";